import { Model, Prop, Vue } from "vue-property-decorator";
import {
    EnumUserRole,
    OrderDto,
    OrderPaymentDetailsDto,
    OrdersFields,
    OrdersSortDirection,
    OrdersTableColumns,
    OrderStatus,
    OrderVehicleStatus,
    SortDirection,
    UserRoleDto,
} from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { Options, setup } from "vue-class-component";
import TableItem from "@/dashboard/my-orders/orders-table/table-item/table-item.vue";
import ProformaPopup from "@/dashboard/my-orders/new-popup/proforma-popup/proforma-popup.vue";
import { eff } from "@/core/utils/effect-ts-abbr";
import { currentUserModel } from "@/shared/state/current-user.model";
import "./orders-table.scss";
import { watch } from "vue";
import Checkbox from "primevue/checkbox";

@Options({
    components: {
        "order-table-item": TableItem,
        Checkbox,
        ProformaPopup,
    },
})
export class OrdersTable extends Vue {
    @Model("_orders", { required: true })
    orders!: readonly OrderDto[];
    @Model("_selectedOrders", { required: true })
    selectedOrders!: Array<OrderDto>;
    @Model("_declineOrderIds", { required: true })
    declineOrderIds!: number[];
    @Model("_viewProformaOrder", { required: true })
    viewProformaOrder!: OrderDto;
    @Model("_approveOrders", { required: true })
    approveOrders!: OrderDto[];
    @Model("sort", { required: true })
    sortBy!: OrdersFields | null;
    @Model("_sortDirection", { required: true })
    sortDirection!: OrdersSortDirection | null;
    @Model("_updateData", { required: true })
    updateData!: boolean;
    @Model("_orderId", { required: true })
    orderId!: number;
    @Model("_orderPaymentDto", { required: true })
    orderPaymentDto!: OrderPaymentDetailsDto;
    @Model("_isPaymentsTransactionsPopup", { required: true })
    isPaymentsTransactionsPopup!: boolean;
    @Prop()
    isLoading!: boolean;
    @Prop()
    currentStatus!: OrderStatus | null;

    pageLoader = pageLoaderModel;
    i18n = setup(useI18n);
    orderTableColumns = OrdersFields;
    isPicked = false;

    beforeMount() {
        this.pageLoader.toggle(true);
    }

    mounted() {
        this.pageLoader.toggle(false);
        watch(
            () => this.currentStatus,
            () => {
                this.isPicked = false;
            },
        );
    }

    changeCurrentSortType(column: OrdersFields) {
        if (column !== this.sortBy) {
            this.sortBy = column;
            this.sortDirection = OrdersSortDirection.ASC;
            return;
        }
        if (this.sortDirection === OrdersSortDirection.DESC) {
            this.sortDirection = OrdersSortDirection.ASC;
            // this.sortBy = OrdersFields.Date;
        } else {
            this.sortDirection = OrdersSortDirection.DESC;
        }
        // else {
        //     this.sortDirection = OrdersSortDirection.ASC;
        // }
    }

    sortingClass(column: OrdersFields): string {
        if (column === this.sortBy) {
            if (this.sortDirection === OrdersSortDirection.ASC) {
                return "dashboard__table-sorting--asc";
            } else if (this.sortDirection === OrdersSortDirection.DESC) {
                return "dashboard__table-sorting--desc";
            }
        }
        return "";
    }

    get sortAria() {
        switch (this.sortDirection) {
            case OrdersSortDirection.ASC:
                return "ascending";
            case OrdersSortDirection.DESC:
                return "descending";
            default:
                return "none";
        }
    }

    get allowedCheckbox() {
        // return this.canApprove && this.currentStatus === String("to_approve");
        return false;
    }

    pickAll(e) {
        if (!e.target.checked) this.selectedOrders = [];
        if (e.target.checked) this.selectedOrders = this.availableOrders;
        this.isPicked = e.target.checked;
    }

    get availableOrders(): Array<OrderDto> {
        return eff.fn.pipe(
            this.orders,
            eff.array.filter((_order) => {
                if (this.currentStatus === String("to_approve")) {
                    return _order?.status.id === OrderVehicleStatus["Awaiting Approval"];
                }
                // if (_order?.status === OrderStatus.to_pay) {
                //     if (_order?.mollyStatus) {
                //         return !(
                //             _order?.mollyStatus.toUpperCase() in
                //             ["INITIATED", "OPEN", "PENDING", "AUTHORIZED"]
                //         );
                //     }
                //     return !_order?.manualTransfer;
                // }
                return true;
            }),
            eff.array.toMutable,
        );
    }

    get canApprove() {
        return (
            currentUserModel.userDto.value !== undefined &&
            currentUserModel.userDto.value?.role.id >= EnumUserRole.PURCHASOR
        );
    }
}
